/**
 * Environment configuration with type-safe access
 */

export const env = {
  app: {
    name: import.meta.env.VITE_APP_NAME || 'Play for Goals',
    url: import.meta.env.VITE_APP_URL || 'http://localhost:5173',
  },

  api: {
    baseUrl: import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000',
    version: import.meta.env.VITE_API_VERSION || 'v1',
  },

  features: {
    enableDevTools: import.meta.env.VITE_ENABLE_DEV_TOOLS === 'true',
  },

  isDevelopment: import.meta.env.DEV,
  isProduction: import.meta.env.PROD,
  mode: import.meta.env.MODE,
} as const;

export function validateEnv() {
  const errors: string[] = [];

  if (!env.api.baseUrl && env.isProduction) {
    errors.push('VITE_API_BASE_URL is required in production');
  }

  if (errors.length > 0) {
    throw new Error(
      `Environment validation failed:\n${errors.map((err) => `  - ${err}`).join('\n')}`
    );
  }
}
